export const DEVICE_UPDATE_LIST = 'DEVICE_UPDATE_LIST';
